import React from 'react';
import { ThomasMainData, ThomasMain } from 'models/interfaces';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { PureQueryOptions } from 'apollo-client';
import { Alert } from 'react-bootstrap';
import { LIST_ADVERTISERS_REDUCED_QUERY } from 'containers/ThomasAdvertiserListContainer';
export interface ThomasMainListProps {
  data?: ThomasMainData;
}
const THOMASADVERTISER_SAVE_QUERY = gql`
  mutation saveThomasAdvertiser($tgrams_id: ID!, $name: String!) {
    saveThomasAdvertiser(tgrams_id: $tgrams_id, name: $name) {
      tgrams_id
      name
    }
  }
`;

function refetchAdvertisers() {
  const refetchAdvertisers = {
    query: LIST_ADVERTISERS_REDUCED_QUERY
  } as PureQueryOptions;
  return [refetchAdvertisers];
}

const ThomasAdvertisersList: React.FunctionComponent<ThomasMainListProps> = ({ data }) => {
  const onErrorAlert = () => {
    console.log('error alert');
  };

  let advertisersList: any[] = [];
  if (data && data.thomasMainLike) {
    advertisersList = data.thomasMainLike.map((x: ThomasMain, i) => (
      <tr key={x.acct}>
        <td>{x.company}</td>
        <td>{x.acct}</td>
        <td>
          {x.thomasAdvertiser != null && (
            <Link to={`/advertisers/${x.acct}`}>
              <button className="btn btn-outline-secondary">view</button>
            </Link>
          )}

          {x.thomasAdvertiser == null && (
            <Mutation
              mutation={THOMASADVERTISER_SAVE_QUERY}
              onError={onErrorAlert}
              onCompleted={() => {}}
              refetchQueries={refetchAdvertisers()}
            >
              {(
                saveThomasAdvertiser: (arg0: {
                  variables: { tgrams_id: string; name: string };
                }) => void,
                { loading, error, called }: any
              ) => (
                <div>
                  {!called && (
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        saveThomasAdvertiser({
                          variables: { tgrams_id: x.acct, name: x.company }
                        })
                      }
                    >
                      add
                    </button>
                  )}
                  {called && (
                    <Link to={`/advertisers/${x.acct}`}>
                      <button className="btn btn-outline-secondary">view</button>
                    </Link>
                  )}
                  {error && <span />}
                </div>
              )}
            </Mutation>
          )}
        </td>
      </tr>
    ));
  }
  if (data && data.thomasMainLike && data.thomasMainLike.length > 0) {
    return (
      <table className="table hover blueprint-table table-wrap">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>tgram_Id</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{advertisersList}</tbody>
      </table>
    );
  } else {
    return <Alert variant="danger">No results</Alert>;
  }
};

export default ThomasAdvertisersList;
